import { SegmentComponent, SpinnerComponent } from "@/types/landing";
import { Instruction } from "@/components/landing/Instruction";
import { LeadFormPopup } from "src/components/landing/LeadFormPopup";
import { Wheel } from "src/components/landing/Wheel";
import { useState } from "react";
import styles from "./Spinner.module.css";

export type SpinStartEnd = {
    start: number;
    end: number;
};

export const Spinner: SpinnerComponent = ({
    site,
    landingPage,
    isModalOpen,
    setIsModalOpen,
    setLoaderIsOpen,
    userCookie
}) => {
    const spinner = landingPage.data?.attributes?.spinner?.data?.attributes;

    const segments = spinner?.segments;
    // Will always return the first winning segment
    // Other segments with "winnable" set to true will be ignored
    const segmentIsWinnable = (segment: SegmentComponent) => segment?.winnable;
    const winningSegment = segments?.find(segmentIsWinnable);
    const winningSegmentIndex = segments?.findIndex(segmentIsWinnable) || 0;
    const [spinStartEnd, setSpinStartEnd] = useState<SpinStartEnd>({
        start: 0,
        end: 0,
    });

    return (
        <>
            <Wheel
                site={site}
                landingPage={landingPage}
                setIsModalOpen={setIsModalOpen}
                winningSegmentIndex={winningSegmentIndex}
                spinStartEnd={spinStartEnd}
                setSpinStartEnd={setSpinStartEnd}
            />
            <LeadFormPopup
                winningSegment={winningSegment}
                site={site}
                landingPage={landingPage}
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                spinStartEnd={spinStartEnd}
                setLoaderIsOpen={setLoaderIsOpen}
                userCookie={userCookie}
            />
            {
                // Only display the instruction if a spinner and instructions are assigned.
                // The instructions are currently only designed for the spinner and are not intended
                // to be used on their own.
                landingPage?.data?.attributes?.instruction_group ? (
                    <div className={styles.instructionsContainer}>
                        <Instruction
                            instructionGroup={
                                landingPage.data?.attributes?.instruction_group
                                    ?.data?.attributes
                            }
                        />
                    </div>
                ) : null
            }
        </>
    );
};
